import React, { memo } from 'react';

import {
  Box,
  Button,
  SpaceBetween,
  Table,
} from '@amzn/awsui-components-react-v3';


import {
  AsyncState,
  Serial,
  ValidationStatusType,
} from '../../store/types';
import { SerialActions } from './SerialActions';
import { SerialNumber } from './SerialNumber';
import { SerialStatus } from './SerialStatus';
import { SERIAL_ERROR_CODES } from './constants';

import './scanSerials.scss';


const SerialsTable = memo(({
  containerId,
  serials,
  disabled = false,
  onHandleSiteSpecificSerialScanned,
  handleOnDeleteSerials
}: any) => {
  return (
    <div className="serials-main-table">
      <Box margin={{ top: 'l' }}>
        <Table
          resizableColumns
          columnDefinitions={[
            {
              id: 'rowIndex',
              header: 'Row Index',
              cell: (item: Serial) => {
                const index = serials.findIndex((s: Serial) => s.id === item?.id);
                return (
                  <div className="row-index">
                    <SpaceBetween size="s" direction="horizontal">
                      <Button
                        variant="inline-icon"
                        onClick={() => handleOnDeleteSerials([item])}
                        iconName="close"
                        disabled={disabled}
                      >
                        Delete
                      </Button>
                      {index + 1}
                    </SpaceBetween>
                  </div>
                );
              },
              isRowHeader: true,
              width: 120,
            },
            {
              id: 'serialNumber',
              header: 'Serial Number',
              cell: (item: Serial) => <SerialNumber serial={item} disabled={disabled} />,
              width: 250,
            },
            {
              id: 'status',
              header: disabled ? 'Receive Status' : 'Validation Status',
              cell: (item: Serial) => {
                return (
                  <SerialStatus serial={item} processing={disabled} containerId={containerId} />
                );
              },
              width: 200,
            },
            {
              id: 'action',
              header: disabled ? 'Reason Code' : 'Action Required',
              cell: (item: Serial) => {
                const validationCode =
                  item?.status?.validationStatusType !== ValidationStatusType.OK
                    ? item?.status?.statusCode
                    : null;
                const receievStatusCode =
                  item.receiveStatus?.receiveStatusType === AsyncState.ERROR
                    ? item.receiveStatus?.statusCode || SERIAL_ERROR_CODES.SERIAL_UNEXPECTED_ERROR
                    : null;
                const errorCode = disabled ? receievStatusCode : validationCode;

                return errorCode ? (
                  <SerialActions
                    errorCode={errorCode}
                    serial={item}
                    onRescan={onHandleSiteSpecificSerialScanned}
                    onCancel={() => { }}
                  />
                ) : null;
              },
            },
          ]}
          columnDisplay={[
            { id: 'rowIndex', visible: true },
            { id: 'serialNumber', visible: true },
            { id: 'status', visible: true },
            { id: 'action', visible: true },
          ]}
          items={serials}
          loadingText="Loading resources"
          trackBy="id"
        />
      </Box>
    </div>
  );
});

export default SerialsTable;
